module.exports = __webpack_public_path__ + "media/images/dummy-content/user-2-b6cafccd91b4418e1ea79c59eb51aeb7.jpg";